module.exports = __webpack_public_path__ + "img/sample-west-old.fa2bbd41.png";